export var getHeight = function getHeight(height, isFullBleed, isFluid) {
  return isFullBleed || isFluid ? '100%' : height;
};